/* eslint-disable @typescript-eslint/camelcase */
import i18n from 'i18n';
import { messagesRequest } from 'modules/messages/actions';
import { modalClose } from 'modules/modal/actions';
import { all, put, takeLatest } from 'redux-saga/effects';
import {
  applyAdvisorFulfilled,
  applyAdvisorRejected,
  applyAdvisorRequest,
  getAdvisorFulfilled,
  getAdvisorRejected,
  getAdvisorRequest,
  getAllAdvisorsFulfilled,
  getAllAdvisorsRejected,
  getAllAdvisorsRequest,
  getDashboardFulfilled,
  getDashboardRejected,
  getDashboardRequest,
  ignoreAdvisorFulfilled,
  ignoreAdvisorRejected,
  ignoreAdvisorRequest,
  revertAdvisorFulfilled,
  revertAdvisorRejected,
  revertAdvisorRequest,
} from './actions';
import endpoints, { api, QueryProps } from './endpoints';

function* getAllAdvisorsRequestSaga({ payload }) {
  const { query } = payload;

  try {
    const { data } = yield api.get({
      url: endpoints.getAllAdvisors(query),
    });

    return yield put(getAllAdvisorsFulfilled(data));
  } catch (error) {
    return yield put(getAllAdvisorsRejected(error));
  }
}

function* getAdvisorRequestSaga({ payload }) {
  try {
    const { data } = yield api.get({
      url: endpoints.getAdvisor(payload),
    });

    return yield put(getAdvisorFulfilled(data));
  } catch (error) {
    return yield put(getAdvisorRejected());
  }
}

function* applyAdvisorRequestSaga({ payload }) {
  const { advisorUuid, getAdvisorsFn } = payload;

  try {
    const { data } = yield api.post({
      url: endpoints.applyAdvisor(advisorUuid),
    });

    return yield all([
      put(applyAdvisorFulfilled()),
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t(data.message.code.toUpperCase()),
        })
      ),
      getAdvisorsFn(),
    ]);
  } catch (error) {
    return yield put(applyAdvisorRejected());
  }
}

function* ignoreAdvisorRequestSaga({ payload }) {
  const { advisorUuid, ignored_reason, getAdvisorsFn } = payload;

  try {
    const { data } = yield api.post({
      url: endpoints.ignoreAdvisor(advisorUuid),
      data: {
        ignored_reason,
      },
    });

    return yield all([
      put(ignoreAdvisorFulfilled()),
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t(data.message.code.toUpperCase()),
        })
      ),
      getAdvisorsFn(),
      put(modalClose()),
    ]);
  } catch (error) {
    return yield put(ignoreAdvisorRejected());
  }
}

function* revertAdvisorRequestSaga({ payload }) {
  const { advisorUuid, getAdvisorsFn } = payload;

  try {
    const { data } = yield api.post({
      url: endpoints.revertAdvisor(advisorUuid),
    });

    return yield all([
      put(revertAdvisorFulfilled()),
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t(data.message.code.toUpperCase()),
        })
      ),
      getAdvisorsFn(),
      put(modalClose()),
    ]);
  } catch (error) {
    return yield put(revertAdvisorRejected());
  }
}

function* getDashboardRequestSaga({
  payload,
}: {
  payload: { query: QueryProps };
}) {
  const { query } = payload;

  try {
    const { data } = yield api.get({
      url: endpoints.getDashboard(query),
    });

    return yield put(getDashboardFulfilled(data));
  } catch (error) {
    return yield put(getDashboardRejected());
  }
}

export default all([
  takeLatest(getAllAdvisorsRequest, getAllAdvisorsRequestSaga),
  takeLatest(getAdvisorRequest, getAdvisorRequestSaga),
  takeLatest(applyAdvisorRequest, applyAdvisorRequestSaga),
  takeLatest(ignoreAdvisorRequest, ignoreAdvisorRequestSaga),
  takeLatest(getDashboardRequest, getDashboardRequestSaga),
  takeLatest(revertAdvisorRequest, revertAdvisorRequestSaga),
]);
